import { render, staticRenderFns } from "./IssueDialog.vue?vue&type=template&id=143ef726&"
import script from "./IssueDialog.vue?vue&type=script&lang=js&"
export * from "./IssueDialog.vue?vue&type=script&lang=js&"
import style0 from "./IssueDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports